import React from "react";
import StatsCard, { StatsCardProps } from "./StatsCard";

interface StatsGroupProps {
  items: StatsCardProps[];
}

const StatsGroup = ({ items }: StatsGroupProps) => {
  return (
    <div className="shadow-sm d-flex border w-100 br-10 bg-white">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <StatsCard
            {...item}
            showInitialBorder={index === 0}
            showLastBorderRadius={(items || []).length - 1 === index}
            popoverId={`stats-popover-${index}`}
          />
          {index !== items.length - 1 && <div className="border-end" />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StatsGroup;
